import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UpdateNotifierService } from '../services/update/update-notifier.service';

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
  constructor(
    private localSt: LocalStorageService,
    private updateNotifierService: UpdateNotifierService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(evt => {
        if (evt instanceof HttpResponse) {
          const header = evt.headers.get('X-Api-Version');
          if (!header) return;

          const currentVersion = this.localSt.retrieve('apiVersion');

          if (currentVersion && header.indexOf(currentVersion)) {
            this.updateNotifierService.setUpdateAvailable(true);
          }

          this.localSt.store('apiVersion', header);
        }
      })
    );
  }
}
